    <app-indicadores [dashBoardId]="4">
    </app-indicadores>